<template>
  <b-card title="Создать игру">
    <b-overlay
      :show="isLoading"
      rounded="sm"
    >
      <b-form @submit.prevent="onSubmit">
        <b-form-group
          label="Тип"
          label-for="builder-type"
          class="mb-2"
        >
          <v-select
            id="builder-type"
            v-model="gameType"
            :options="typeOptions"
            :reduce="val => val.value"
            placeholder="Выберите тип"
          />
        </b-form-group>

        <b-button
          variant="primary"
          type="submit"
          :disabled="!gameType || isLoading"
        >
          <span v-if="isLoading">
            <b-spinner small />
            Создание...
          </span>
          <span v-else>
            Создать
          </span>
        </b-button>
      </b-form>
    </b-overlay>
  </b-card>
</template>

<script>
import {
  BCard, BForm, BFormGroup, BButton, BOverlay, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BForm,
    BFormGroup,
    BButton,
    BOverlay,
    BSpinner,
    vSelect,
  },
  setup(props, { emit }) {
    const gameType = ref('movies')
    const isLoading = ref(false)

    const typeOptions = [
      { value: 'movies', label: 'Фильмы' },
      { value: 'series', label: 'Сериалы' },
    ]

    const onSubmit = () => {
      isLoading.value = true
      emit('create', { type: gameType.value })
    }

    const stopLoading = () => {
      isLoading.value = false
    }

    return {
      gameType,
      isLoading,
      typeOptions,
      onSubmit,
      stopLoading,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
